/**
 * Sponsorship API types shared between API and UI.
 */
// ---------------------------------------------------------------------------
// API client
// ---------------------------------------------------------------------------
export class SponsorshipApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async getStatus() {
        return this.client.get('/api/sponsorship/status');
    }
    async createRequest(params) {
        return this.client.post('/api/sponsorship/request', params);
    }
    async withdrawRequest() {
        return this.client.delete('/api/sponsorship/request');
    }
    async getDirectory(cursor) {
        const query = cursor ? `?cursor=${encodeURIComponent(cursor)}` : '';
        return this.client.get(`/api/sponsorship/directory${query}`);
    }
    async createCheckout(params) {
        return this.client.post('/api/sponsorship/checkout', params);
    }
    async getSponsorStats() {
        return this.client.get('/api/sponsorship/sponsor-stats');
    }
    async setSponsorAchievement(enabled) {
        return this.client.post('/api/sponsorship/sponsor-achievement', { enabled });
    }
}
//# sourceMappingURL=sponsorship-api.js.map